// extracted by mini-css-extract-plugin
export default {"box":"infoContent_box__hJcKu","box__title":"infoContent_box__title__WeWs4","box__item__title":"infoContent_box__item__title__aU90d","gray":"infoContent_gray__X58qr"};